import { inject, Signal } from '@angular/core';
import { ItemsViewService } from '../../@domain/items-view/items-view.service';
import { MetaData, MetaService } from '../../@domain/seo/meta.service';
import { UserService } from '../../@domain/user/application/user.service';

export abstract class BasePage {
    private userService = inject(UserService);
    private metaService = inject(MetaService);
    private itemsViewService = inject(ItemsViewService);

    protected isAdmin = this.userService.isAdmin;
    protected isAuthenticated = this.userService.isAuthenticated;
    protected isGridView: Signal<boolean> = this.itemsViewService.isGridView;

    protected setMeta(meta: MetaData) {
        this.metaService.set(meta);
    }
}
